module.exports = __webpack_public_path__ + "static/media/Frame.652a40db.svg";